import * as licenceActions from '../actions/licences';
import { extract } from '../services/data/licenceBookmarkExtractor';

const initialState = {
    licence: null,
    licenceBookmarks: [],
    licences: []
};

export default (state = initialState, action) => {
    switch (action.type) {

        case licenceActions.LICENCE_RECEIVED:
            return {
                ...state,
                licence: action.licence,
                licenceBookmarks: extract(action.licence)
            };

        case licenceActions.LICENCES_RECEIVED:
            return {
                ...state,
                licences: action.licences
            };

        default:
            return state;
    }
};